(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileQuery = window.matchMedia('(max-width: 989px)');
      this.headerBounds = {};

      this.applyStickyType();

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      // Re-evaluate desktop/mobile sticky behaviour when crossing the breakpoint.
      this.mobileQuery.addEventListener('change', this.applyStickyType.bind(this));

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    // Effective sticky type for the current breakpoint (mobile < 990px uses
    // data-sticky-type-mobile, desktop uses data-sticky-type).
    stickyType() {
      const desktop = this.getAttribute('data-sticky-type') || 'none';
      const mobile = this.getAttribute('data-sticky-type-mobile') || desktop;
      return this.mobileQuery && this.mobileQuery.matches ? mobile : desktop;
    }

    // Recompute always-sticky vs scroll-based behaviour. Called on init and
    // whenever the desktop/mobile breakpoint changes.
    applyStickyType() {
      const type = this.stickyType();
      this.headerIsAlwaysSticky = type === 'always' || type === 'reduce-logo-size';
      this.stickyDisabled = type === 'none';

      if (!this.header) return;

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      } else if (this.stickyDisabled) {
        // Not sticky on this breakpoint: clear all sticky/hidden state.
        this.header.classList.remove(
          'shopify-section-header-sticky',
          'shopify-section-header-hidden',
          'animate'
        );
      }
    }

    setHeaderHeight() {
  if (!this.header) return;
  document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
}

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      this.mobileQuery?.removeEventListener?.('change', this.applyStickyType.bind(this));
    }

    createObserver() {
  if (!this.header) return;
  const observer = new IntersectionObserver((entries, obs) => {
    this.headerBounds = entries[0].intersectionRect;
    obs.disconnect();
  });
  observer.observe(this.header);
}

    onScroll() {
      // Sticky disabled on this breakpoint → header stays in normal flow.
      if (this.stickyDisabled) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
  this.disclosures = this.disclosures || this.header?.querySelectorAll?.('header-menu');
  this.disclosures?.forEach?.((d) => d?.close && d.close());
}

    closeSearchModal() {
  this.searchModal = this.searchModal || this.header?.querySelector?.('details-modal');
  this.searchModal?.close && this.searchModal.close(false);
}
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
